import { motion } from 'framer-motion';
import ShinyText from './ShinyText';
import { useState } from 'react';

export default function AnimatedActionButton({
  text,
  onClick,
  href,
  icon,
  className = '',
  as = 'button',
  ...props
}) {
  const [hovered, setHovered] = useState(false);
  const Comp = as === 'a' ? motion.a : motion.button;

  return (
    <Comp
      href={href}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      whileHover={{
        scale: 1.08,
        backgroundColor: '#000',
        color: '#fff'
      }}
      whileTap={{ scale: 0.96 }}
      transition={{ type: 'spring', stiffness: 300 }}
      className={
        'flex items-center px-6 py-2 border-2 border-black rounded-full text-base font-medium group w-max mt-4 ' +
        className
      }
      style={{ fontFamily: 'Inter, sans-serif' }}
      {...props}
    >
      <ShinyText text={text} disabled={!hovered} className={!hovered ? 'text-black' : ''} />
      {icon !== false && (
        icon ? icon : (
          <motion.svg
            className="ml-2 w-5 h-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
            whileHover={{ x: 4 }}
            transition={{ type: 'spring', stiffness: 300 }}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
          </motion.svg>
        )
      )}
    </Comp>
  );
} 